import React from 'react';
import { Card } from './ui/card';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock';

export const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <div className="inline-block bg-[#D4AF37]/10 text-[#D4AF37] px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Testimonials
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#0F1419] mb-6 playfair">
            What Our Clients Say
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Don't just take our word for it. Hear from our satisfied clients about their experience
            working with NA Realtors.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card
              key={testimonial.id}
              className="p-8 border-2 border-gray-100 hover:border-[#D4AF37]/30 hover:shadow-xl transition-all duration-300 smooth-hover"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Quote Icon */}
              <div className="flex items-start justify-between mb-6">
                <div className="bg-[#D4AF37]/10 p-3 rounded-full">
                  <Quote className="w-6 h-6 text-[#D4AF37]" />
                </div>
                {/* Star Rating */}
                <div className="flex space-x-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-[#D4AF37] text-[#D4AF37]" />
                  ))}
                </div>
              </div>

              {/* Content */}
              <p className="text-gray-700 text-lg leading-relaxed mb-6 italic">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="flex items-center space-x-4 pt-6 border-t border-gray-100">
                <div className="w-12 h-12 bg-gradient-to-br from-[#D4AF37] to-[#B8941F] rounded-full flex items-center justify-center">
                  <span className="text-white font-bold text-lg playfair">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-bold text-[#0F1419] playfair">{testimonial.name}</p>
                  <p className="text-sm text-gray-500">{testimonial.role}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div>
            <div className="text-4xl font-bold text-[#D4AF37] playfair mb-2">4.9/5</div>
            <p className="text-gray-600 text-sm">Client Rating</p>
          </div>
          <div>
            <div className="text-4xl font-bold text-[#D4AF37] playfair mb-2">98%</div>
            <p className="text-gray-600 text-sm">Customer Satisfaction</p>
          </div>
          <div>
            <div className="text-4xl font-bold text-[#D4AF37] playfair mb-2">300+</div>
            <p className="text-gray-600 text-sm">Happy Families</p>
          </div>
          <div>
            <div className="text-4xl font-bold text-[#D4AF37] playfair mb-2">100%</div>
            <p className="text-gray-600 text-sm">Verified Reviews</p>
          </div>
        </div>
      </div>
    </section>
  );
};